var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('center',[_c('h1',{staticClass:"display-4 ma-10"},[_vm._v("OOPS!")]),_c('p',[_vm._v("Looks like we don't have that here.")]),_c('p',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go Home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }